<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <b-checkbox-group
      :options="options"
      v-model="selected"
      :required="selected.length == 0 && required"
      stacked
      size="lg"
      class="custom-checkboxes"
      @change="setHideQuestions"
    >
    </b-checkbox-group>
    <div v-for="item in options" :key="'x' + item.id" class="mx-2">
      <span v-if="isSelected(item.value) && item.need_extra_data">
        <hr class="mb-1 mt-4" />
        <small class="">
          {{ item.text }}
        </small>
        <b-form-input
          class="mb-3"
          v-model="inputExtraData[item.id]"
          placeholder="Enter your answer"
          :required="required"
        ></b-form-input>
      </span>
    </div>
    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import modal from '@/components/practice/modalQuestionPlan.vue';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    modal,
  },
  mixins: [mixinListenerChangeElement],
  props: {
    options: Array,
    question: String,
    index: Number,
    id: Number,
    answers: Array,
    questionPlan: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
  },
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then(() => {
        this.modalQuestion = true;
      });
    },
    isSelected(value) {
      let isElement = false;
      for (let i = 0; i < this.selected.length; i++) {
        const element = this.selected[i];
        if (element == value) {
          isElement = true;
        }
      }
      return isElement;
    },
    setHideQuestions() {
      this.hideQuestions.forEach((element) => {
        let idx = this.$parent.hideQuestions.indexOf(element);
        if (idx > -1) {
          this.$parent.hideQuestions.splice(idx, 1);
        }
      });
      this.hideQuestions = [];

      this.options.forEach((element) => {
        this.selected.forEach((select) => {
          if (element.id == select && element.excluded_questions) {
            element.excluded_questions.forEach((item) => {
              this.hideQuestions.push(item.question_to_skip);
              this.$parent.hideQuestions.push(item.question_to_skip);
            });
          }
        });
      });
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    selected(newQuestion, oldQuestion) {
      this.setHideQuestions();
      this.handleChangeElement({ id: this.id, value: this.selected });
    },
  },
  data() {
    return {
      selected: [],
      inputExtraData: {},
      qid: this.id,
      hideQuestions: [],
      modalQuestion: false,
    };
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.answers.forEach((element) => {
        this.selected.push(element.option_id);
        if ('answer_text_1' in element) {
          this.inputExtraData[element.option_id] = element.answer_text_1;
        }
      });
    }
  },
};
</script>
<style lang="scss">
.custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  font-size: 1rem;
  line-height: 2rem;
}
.custom-checkboxes {
  label {
    span {
      font-weight: 400;
    }
  }
}
</style>
